import { Button, Flex, Text } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import PaginationComp from "components/PaginationComp";
import TableList from "components/TableList";
import { toaster } from "components/ui/toaster";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "services/api";
import utils from "utils";
import storage from "utils/storage";

const headers = [
  "payment number",
  "date",
  "dealer",

  {
    label: "amount",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
  "comment",
];

// const items = [
//   {
//     id: 1,
//     "payment number": "30 Day Admin",
//     date: "30 Day Admin",
//     dealer: "xyz",
//     amount: "123",
//     comment: "njcsbdjfbd kmf",
//   },
// ];

function PaymentsOut() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const [activePage, setActivePage] = useState(1);
  const [searchtxt, setSearchtxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);

  const [dealers, setDealers] = useState();
  const [dealerid, setDealerId] = useState();
  const [totalAmt, setTotalAmt] = useState(0);

  const navigate = useNavigate();

  // const clear = () => {
  //   setSelectedItem();
  //   setDatepayment("");
  //   setPaymentamount(0);
  //   setComment("");
  //   setPaymentnumber("");
  //   setPaymentid("");
  //   // setPaidbyoperator(0);

  //   utils.getDealers({
  //     setIsLoading,
  //     action: "useState",
  //     onDealersChange,
  //     allOption: false,
  //   });
  // };

  const onNew = async () => {
    navigate("/paymentsoutview", {
      state: { action: "paymentsoutview-add" },
    });
  };

  const onDealersChange = (data) => {
    console.log("onDealersChange", data);
    setDealers(data?.list ? [...data.list] : []);
    setDealerId(data?.item?.data?.dealerid || "");
    getList({
      dealerid: data?.item?.data?.dealerid,
      action: data?.action,
      page: 1,
      searchtxt: searchtxt,
    });
    // if (data?.action !== "useState") {
    //   if (data?.item?.data?.dealerid || data?.item?.data?.dealerid === 0) {
    //     getList({
    //       dealerid: data?.item?.data?.dealerid,
    //       action: data?.action,
    //       page: 1,
    //     });
    //   } else {
    //     getList();
    //   }
    // }
    const appcatch = storage.get("appcatch") || {};
    appcatch.paymentout_dealerid = data?.item?.data?.dealerid;
    storage.set("appcatch", appcatch);
  };

  const getList = async (data) => {
    // if (data?.dealerid === undefined || data?.dealerid === null) {
    //   setList([]);
    //   setTotalAmt(0);
    //   return;
    // }
    setIsLoading(true);
    setSelectedItem();
    return api
      .getPayments({
        dealerid: data?.dealerid || dealerid,
        page: data?.page || 1,
        searchtxt: data.searchtxt,
      })
      .then((res) => {
        setIsLoading(false);
        if (res?.status === 200) {
          console.log(res?.data);
          if (data?.page) {
            setActivePage(data.page);
          }

          if (res?.data && res?.data[0]?.paymentid) {
            let totalamount = 0;

            const l = res.data.map((item) => {
              totalamount += parseInt(item?.paymentamount || 0);
              return {
                id: item?.paymentid,
                paymentnumber: item?.paymentnumber,
                date: item?.datepayment
                  ? utils.formatToDDMMYYYY(item?.datepayment)
                  : "",
                dealer: item?.companyname || "", // item?.dealerid,
                amount: utils.formatAmountForTb(item?.paymentamount),
                comment: item?.comment,
                data: item,
              };
            });

            setList(l);
            setTotalAmt(totalamount);
            // clear();
          } else {
            setList([]);
            setTotalAmt(0);
            // clear();
          }
        } else {
          setList([]);
          setTotalAmt(0);
          toaster.create({
            title: res?.message || "error",
            type: "error",
          });
        }
      });
  };

  const onSelectItm = (data) => {
    // setSelectedItem(data);
    // console.log("onSelectItm", data);

    if (data?.item) {
      navigate("/paymentsoutview", {
        state: { action: "paymentsoutview-edit", data: data?.item?.data },
      });
    }

    // const i = data?.item?.data;
    // //   {
    // //     "datepayment": "2017-09-24T18:30:00.000Z",
    // //     "dealerid": 96,
    // //     "paymentamount": 975,
    // //     "comment": "september 2017 retrn",
    // //     "paymentnumber": "AUPAY66",
    // //     "paymentid": 71,
    // //     "paidbyoperator": null
    // // }

    // setDatepayment(i?.datepayment || "");
    // setPaymentamount(i?.paymentamount || 0);
    // setComment(i?.comment || "");
    // setPaymentnumber(i?.paymentnumber || "");
    // setPaymentid(i?.paymentid || "");
    // setPaidbyoperator(i?.paidbyoperator || 0);

    // onDealersChange({
    //   ...utils.getSelectDearerid({ list: dealers, id: i?.dealerid }),
    //   action: "select-item",
    // });
  };

  const onChangeSearchtxt = (v) => {
    setSearchtxt(v);
    getList({ searchtxt: v, page: 1, dealerid: utils.getDealerid(dealers) });
    // setSearchLoading(true);
  };

  const onChangePage = (data) => {
    if (data.page === activePage) {
      return;
    }
    getList({
      page: data.page,
      // limitId: utils.getLimitId(filerLast),
      searchtxt: searchtxt,
      dealerid: utils.getDealerid(dealers),
    });
  };

  useEffect(() => {
    const cb = async () => {
      const appcatch = storage.get("appcatch") || {};

      // if (!appcatch?.paymentout_dealerid) {
      //   await getList({ action: "useState", page: 1 });
      // }

      await utils.getDealers({
        setIsLoading,
        action: "useState",
        onDealersChange,
        allOption: true,
        defaultVal: appcatch?.paymentout_dealerid,
      });
    };
    cb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Payments Out"} isLoading={isLoading} />
      <Flex
        // justify={"space-between"}
        flexFlow={"wrap"}
        gap={"1rem"}
        // alignItems={"center"}
        mb={"1rem"}
        direction={"row"}
      >
        <InputComp
          // label={"Account"}
          type={"dropdown"}
          items={dealers}
          onChange={onDealersChange}
        />

        <Flex flex={1} />
        <ButtonComp
          label="New"
          keyname="new"
          variant="outline"
          onClick={onNew}
        />
        <InputComp
          type={"search"}
          onChange={onChangeSearchtxt}
          value={searchtxt}
        />
      </Flex>
      <TableList
        type={"simple"}
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        selectedItem={selectedItem}
      />
      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
      />

      <Flex
        flexFlow={"wrap"}
        justify={"space-between"}
        gap={"1rem"}
        mt={"1rem"}
      >
        <Button
          w={"14rem"}
          bg={"card.darkgray"}
          color={"textv2.lite"}
          // onClick={onSa}
          justifyContent={"space-between"}
        >
          <Text fontWeight="medium" textStyle={"md"}>
            Total
          </Text>
          <Text fontWeight="medium" textStyle={"md"}>
            {utils.formatCurrency(totalAmt)}
          </Text>
        </Button>
      </Flex>
    </Flex>
  );
}

export default PaymentsOut;
